import axios from "axios";
import { CONFIG } from "../../config";

export const getProfile = async () => {
  const result = await axios.get(`${CONFIG.API_URL}/c/m/getProfile`);

  return result?.data?.data;
};
